import { PermissionCode } from "@/constants/permissions";
import { AppRoutes } from "@/constants/routes";
import { Permiso } from "@/pages/role-asignation/schema/role-assignation.schema";
import { Flex, Link } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

interface Props {
  permissions: Permiso[];
}

export const ATAProdView = ({ permissions }: Props) => {
  const navigate = useNavigate();

  const hasAccess = (codigo: string) =>
    permissions?.some((p) => p.codigo === codigo && p.tipoPermiso === "R");

  const canUseFieldVisit = hasAccess(PermissionCode.FIELD_VISIT);
  const canUseProductPlanification = hasAccess(PermissionCode.PRODUCT_PLANIFICATION);
  const canUseGrossMargin = hasAccess(PermissionCode.GROSS_MARGIN_REQUESTS)
  const canUseEstablishmentsFieldRequests = hasAccess(PermissionCode.ESTABLISHMENTS_FIELDS_REQUESTS);

  return (
    <Flex flexDir="column" paddingX={2} paddingY={1} gap="10px">
      {canUseFieldVisit && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.FIELD_VISIT)}>
          Visita a campo
        </Link>
      )}
      {canUseProductPlanification && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.PRODUCT_PLANIFICATION)}>
          Planificación productiva
        </Link>
      )}
      {
        canUseGrossMargin && (
          <Link variant="plain" onClick={() => navigate(AppRoutes.GROSS_MARGIN_REQUESTS)}>
            Margen Bruto Personal
          </Link>
        )
      }
      {
        canUseEstablishmentsFieldRequests && (
          <Link variant="plain" onClick={() => navigate(AppRoutes.ESTABLISMENT_FIELD_REQUESTS)}>
            Solicitudes de establecimientos
          </Link>
        )
      }
    </Flex>
  );
};
